<div class="content-info">
  <div class="content-title">
    <h3 class="title">Stock Takes</h3>
    <div class="title-actions">
      <label class="zf-search" title="Search by stock take number or SKU">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search stock take # or SKU" />
      </label>
      <!-- Downloads Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="downloadsDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="bi bi-download"></i> Downloads
        </button>
        <ul class="dropdown-menu" aria-labelledby="downloadsDropdown">
          <li>
            <h6 class="dropdown-header">Templates</h6>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadTemplate()">
              Stock Take Template
            </a>
          </li>
        </ul>
      </div>

      <button class="btn btnprimary" [routerLink]="['/stocktake/create']">
        <i class="bi bi-plus-lg"></i> New stock take
      </button>
    </div>
  </div>

  <!-- TABS -->
  <div class="zf-card-head">
    <div class="zf-tabs">
      <button type="button" class="zf-tab" [class.active]="activeTab === 'sessions'" (click)="switchTab('sessions')">
        Active sessions
      </button>
      <button type="button" class="zf-tab" [class.active]="activeTab === 'drafts'" (click)="switchTab('drafts')">
        Drafts / uploads
      </button>
    </div>
  </div>

  <!-- SESSIONS TAB CONTENT -->
  <div *ngIf="activeTab === 'sessions'" class="common-table">

    <!-- Merge workflow views: keeps "waiting to merge", "merged - review &
         complete" and "already absorbed children" out of one confusing list -->
    <div class="zf-card-head pt-0">
      <div class="zf-tabs">
        <button type="button" class="zf-tab" [class.active]="sessionView === 'all'" (click)="setSessionView('all')">All</button>
        <button type="button" class="zf-tab" [class.active]="sessionView === 'toMerge'" (click)="setSessionView('toMerge')">
          <i class="bi bi-intersect me-1"></i> To merge
        </button>
        <button type="button" class="zf-tab" [class.active]="sessionView === 'toReview'" (click)="setSessionView('toReview')">
          <i class="bi bi-clipboard-check me-1"></i> To review
        </button>
        <button type="button" class="zf-tab" [class.active]="sessionView === 'completed'" (click)="setSessionView('completed')">
          <i class="bi bi-check-circle me-1"></i> Completed
        </button>
        <button type="button" class="zf-tab" [class.active]="sessionView === 'merged'" (click)="setSessionView('merged')">
          <i class="bi bi-archive me-1"></i> Merged
        </button>
      </div>
      <div class="zf-tabs-right ms-auto" [ngSwitch]="sessionView">
        <span *ngSwitchCase="'toMerge'">Submitted device counts waiting to be merged — select 2 or more and click Merge.</span>
        <span *ngSwitchCase="'toReview'">Merged master sessions — review the counts / variance, then Complete to apply to inventory.</span>
        <span *ngSwitchCase="'completed'">Stock takes already applied to inventory.</span>
        <span *ngSwitchCase="'merged'">Device sessions already absorbed into a master (reference only).</span>
      </div>
    </div>

    <div class="zf-toolbar">
      <div class="zf-toolbar-field" style="min-width: 220px">
        <label>Store</label>
        <select class="form-select" [(ngModel)]="sessionFilter.storeId" (change)="applySessionFilters()">
          <option value="">All stores</option>
          <option [value]="s.id" *ngFor="let s of stores">{{ s.name || s.storeName }}</option>
        </select>
      </div>
      <div class="zf-toolbar-field">
        <label>From date</label>
        <input type="date" class="form-control" [(ngModel)]="sessionFilter.fromDate" (change)="applySessionFilters()" />
      </div>
      <div class="zf-toolbar-field">
        <label>To date</label>
        <input type="date" class="form-control" [(ngModel)]="sessionFilter.toDate" (change)="applySessionFilters()" />
      </div>
      <!-- Status is fixed by the workflow view except on "All" -->
      <div class="zf-toolbar-field" *ngIf="sessionView === 'all'" style="min-width: 140px">
        <label>Status</label>
        <select class="form-select" [(ngModel)]="sessionFilter.status" (change)="applySessionFilters()">
          <option value="">All status</option>
          <option value="DRAFT">Draft</option>
          <option value="IN_PROGRESS">In progress</option>
          <option value="COMPLETED">Completed</option>
          <option value="MERGED">Merged</option>
        </select>
      </div>
      <button class="btn btn-sm btn-outline-secondary" (click)="resetSessionFilters()">Reset</button>
      <span class="zf-toolbar-spacer"></span>
      <button class="btn btn-sm btnprimary" (click)="mergeSelected(previewModal)"
        [disabled]="selectedSessionIds.size < minMergeCount">
        <i class="bi bi-intersect"></i> Merge ({{ selectedSessionIds.size }})
      </button>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">
              <i class="bi bi-check-square"></i>
            </th>
            <th>Session #</th>
            <th>Type</th>
            <th>Store</th>
            <th>Started By</th>
            <th>Scanned By</th>
            <th>Started At</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="9" class="text-center py-4">Loading sessions…</td>
          </tr>
          <tr *ngIf="!loading && sessions.length === 0">
            <td colspan="9"><div class="zf-empty"><strong>No sessions in this view</strong><span>Start a stock take or switch the view above.</span></div></td>
          </tr>
          <tr *ngFor="let s of sessions">
            <td class="text-center">
              <!-- Only mergeable rows get a checkbox at all — a greyed-out box
                   on every other row is just visual noise. -->
              <input *ngIf="canMerge(s)" type="checkbox" class="form-check-input"
                [checked]="selectedSessionIds.has(s.id)"
                (change)="toggleSelection(s.id)" />
            </td>
            <td>
              <a [routerLink]="['/stocktake/session', s.id]" class="zf-mono fw-semibold">
                {{ s.stockTakeSessionNumber }}
              </a>
            </td>
            <td>
              <span class="zf-status" [ngClass]="{
                  info: s.sessionType === 'REGULAR',
                  primary: s.sessionType === 'MASTER'
                }">{{ s.sessionType || "REGULAR" }}</span>
            </td>
            <td>{{ getStoreName(s.storeId) }}</td>
            <td>{{ s.startedByName || getUserName(s.startedBy) }}</td>
            <td>{{ s.scannedByNames || '-' }}</td>
            <td>{{ s.startedAt | date: "dd-MMM-yyyy hh:mm a" }}</td>
            <td>
              <!-- Contextual: IN_PROGRESS reads as TO MERGE (device session)
                   or TO REVIEW (master) — matching the workflow tabs above -->
              <span class="badge" [ngClass]="statusClass(s)">{{ statusLabel(s) }}</span>
            </td>
            <td>
              <div class="d-flex gap-1">
                <button *ngIf="s.id" [routerLink]="['/stocktake/session', s.id]" class="btn btn-sm btn-outline-secondary"
                  title="View session">
                  <i class="bi bi-eye"></i>
                </button>
                <!-- Variance report: merged MASTER sessions get it even while
                     IN_PROGRESS (review before completing) -->
                <button *ngIf="s.sessionType === 'MASTER' || s.status === 'COMPLETED' || s.status === 'MERGED'"
                  (click)="downloadVarianceReport(s.id)"
                  class="btn btn-sm btn-outline-secondary" title="Download variance report">
                  <i class="bi bi-file-earmark-excel"></i> Variance
                </button>
                <button *ngIf="s.sessionType === 'REGULAR'"
                  (click)="downloadRegularReport(s.id)"
                  class="btn btn-sm btn-outline-secondary" title="Download regular report (per-scan lines)">
                  <i class="bi bi-file-earmark-excel"></i> Report
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination for Sessions -->
    <app-pagination [page]="sessionFilter.page" [limit]="sessionFilter.limit" [pageCount]="sessionPageCount"
      (pageChange)="onSessionPageChange($event)" (limitChange)="onSessionLimitChange($event)">
    </app-pagination>
  </div>

  <!-- DRAFTS TAB CONTENT (Existing) -->
  <div *ngIf="activeTab === 'drafts'" class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Stock Take #</th>
            <th>Mode</th>
            <th>Total Lines</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="6" class="text-center">Loading stock takes…</td>
          </tr>

          <tr *ngIf="!loading && stockTakes.length === 0">
            <td colspan="6"><div class="zf-empty"><strong>No stock take drafts</strong><span>Upload a count sheet or create a stock take.</span></div></td>
          </tr>

          <tr *ngFor="let st of stockTakes">
            <td>
              <a [routerLink]="['/stocktake/edit', st.id]" [queryParams]="{ view: true }">
                {{ st.stockTakeNumber || "—" }}
              </a>
            </td>
            <td>
              <span class="zf-status" [ngClass]="{ info: st.mode === 'FULL' }">{{ st.mode }}</span>
            </td>

            <td>{{ st.totalLines || 0 }}</td>
            <td>
              <span class="zf-status" [ngClass]="{
                  primary: st.status === 'DRAFT',
                  ok: st.status === 'SUBMITTED',
                  danger: st.status === 'CANCELLED'
                }">{{ st.status }}</span>
            </td>
            <td>{{ st.createdAt | date: "dd-MMM-yyyy hh:mm a" }}</td>
            <td>
              <div class="td-actions-btn d-flex gap-1">
                <button *ngIf="st.status === 'DRAFT'" class="btn btn-edit" [routerLink]="['/stocktake/edit', st.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <!-- Same variance workbook as the Active Sessions tab, sourced
                     from the uploaded draft lines -->
                <button *ngIf="st.status === 'DRAFT' || st.status === 'SUBMITTED'"
                  (click)="downloadDraftVarianceReport(st.id, st.stockTakeNumber)"
                  class="btn btn-sm btn-outline-secondary" title="Download variance report">
                  <i class="bi bi-file-earmark-excel"></i> Variance
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount"
      (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>
<!-- Preview Modal -->
<ng-template #previewModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Merge Preview</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="previewLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!previewLoading">
      <div class="alert alert-info">
        Merging <strong>{{ selectedSessionIds.size }}</strong> sessions. Items
        will be aggregated by SKU.
      </div>

      <div class="table-responsive" style="max-height: 500px; overflow-y: auto">
        <table class="table table-bordered table-striped table-sm sticky-header">
          <thead class="table-light">
            <tr>
              <th>SKU</th>
              <th>Description</th>
              <!-- Dynamic Columns for each session -->
              <th *ngFor="let s of getSelectedSessions()" class="text-end">
                {{ s }}
              </th>
              <th class="text-end table-primary fw-bold">Total Qty (After)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewItems">
              <td class="fw-bold">{{ item.sku }}</td>
              <td>
                <small>{{ item.description }}</small>
              </td>
              <!-- Qty per session -->
              <th *ngFor="let s of getSelectedSessions()" class="text-end fw-normal">
                {{ item.sessionQtys[s] ? (item.sessionQtys[s] | number : "1.0-3") : "-" }}
              </th>
              <td class="text-end table-primary fw-bold">{{ item.total | number : "1.0-3" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel')">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmMerge(modal)" [disabled]="previewLoading">
      Confirm Merge
    </button>
  </div>
</ng-template>